import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { InfoService } from '@app/core/info/info.service';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, Subject,of } from 'rxjs';
import { catchError, takeUntil,switchMap } from 'rxjs/operators';
import { isNumber } from 'util';
import { ActivationStep, BissCheckStep, DownloadLinkData } from '../activation.model';
import { BissManager } from '../services/biss-manager';
import { IBissPorts } from '../services/ibiss';
import { AngularDeviceInformationService, DeviceInfo } from 'angular-device-information';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivationService } from '../services/activation.service';

@Component({
  selector: 'cloud-biss-check',
  templateUrl: './biss-check.component.html',
  styleUrls: ['./biss-check.component.scss']
})
export class BissCheckComponent implements OnInit {

  @Output() 
  stepCompleteEvent = new EventEmitter();
  
  bissCheckStep: BissCheckStep;

  private unsubscribe$: Subject<void> = new Subject<void>();
  operatingSystem: string;
  downloadInfo: DownloadLinkData;

  constructor(  
    public info: InfoService,
    private translateService: TranslateService,
    private bissManager: BissManager,
    private deviceInfoService: AngularDeviceInformationService,
    private activationService: ActivationService,
    private http: HttpClient) { 
      
    }


  ngOnInit() {
    this.operatingSystem = this.deviceInfoService.isDesktop() ? this.deviceInfoService.getDeviceInfo().os : 'WINDOWS';
    if (this.operatingSystem) {
      this.activationService.getDownloadInfo(this.mapOperatingSystem(this.operatingSystem)).subscribe((res:any) => {
        if (res.status === 200) {
          this.downloadInfo = res.data;
          this.checkBissActive();
        }
      })
    } else {
      this.info.error(this.translateService.instant('activation.biss.osNotSupported'));
    }
  }

  mapOperatingSystem(os: string) {
    if (os.toLowerCase().includes('mac')) {
      return 'MAC';
    }
    return os;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  checkBissActive(){
    this.bissCheckStep = BissCheckStep.ONGOING;
 
    this.checkBiss()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(r=>{
      if(isNumber(r)){
       this.bissCheckStep = BissCheckStep.FOUND
      }
      if(this.bissCheckStep === BissCheckStep.ONGOING){
        this.bissCheckStep = BissCheckStep.NOT_FOUND
      }
    });
  }

  tryAgain() {
    this.checkBissActive();
  }

  public checkBiss(): Observable<any> {
    const ports = [53952, 53953, 53954];
    const checks:Observable<any>[] = [];
    let activePort;
    for (const port of ports) {
        const obs = this.http.get('https://localhost:' + port + '/version')
            .pipe(catchError(e => of(e)));
        checks.push(obs);

        obs
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res: IBissPorts) => {
          if (res.version != null && res.version != undefined) {  
            if (res.version >= this.downloadInfo.bissMinVersion) {
              activePort = port;
            } else {
              this.bissCheckStep = BissCheckStep.FOUND_OLD_VERSION
            }
          }
        });
    }
    return forkJoin({...checks}).pipe(
        switchMap(() => {
            if (activePort !== undefined) {

                return of(activePort);
            } else {
                return of(null);
            }
        }));
  }

  bissCheckOngoing() {
    return this.bissCheckStep ==  BissCheckStep.ONGOING;
  }
  bissNotFound() {
    return this.bissCheckStep == BissCheckStep.NOT_FOUND;
  }
  bissFound() {
    return this.bissCheckStep == BissCheckStep.FOUND;
  }
  bissFoundOldVersion() {
    return this.bissCheckStep == BissCheckStep.FOUND_OLD_VERSION;
  }
  stepComplete() {
    this.stepCompleteEvent.emit(ActivationStep.BISS);
  } 
}
